// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"ww_a bik_b","TwoDimsListFeature__item":"ww_b bik_we","TwoDimsListFeature__item__text":"ww_c bik_vt"};